module.exports = __webpack_public_path__ + "img/2006.d6a7350a.png";